import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { LayoutData } from "@ServerTypes/portal/portal.schema";

// State shape is the server `LayoutData` (from `@ServerTypes/portal/portal.schema`),
// the single source of truth — the portal `metaData` payload returned by `GET /portal/getLayoutData`.
const initialState: LayoutData = {};

const layoutSlice = createSlice({
  name: "layout",
  initialState,
  reducers: {
    setLayout: (
      state: LayoutData,
      action: PayloadAction<Partial<LayoutData> | Record<string, unknown> | undefined>,
    ) => {
      Object.assign(state, action.payload);
    },
  },
});

export const { setLayout } = layoutSlice.actions;

export default layoutSlice.reducer;
